import React, { useEffect, useState } from "react";
import { AutoComplete, DatePicker } from "../../components/_index";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  Divider,
  TableCell,
  TableRow,
  Table,
  TableHead,
  TableBody,
  TableContainer,
  Autocomplete,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch } from "react-redux";
import { Formik, Form, Field } from "formik";
import Grid from "@mui/material/Grid2";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { FileUploader } from "react-drag-drop-files";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { postProject, updateProject } from "../../services/project.service";
import { getClient } from "../../services/clientManagement.service";
import { getForm } from "../../services/form.service";
import { getUser } from "../../services/user.service";
import { useLocation } from "react-router-dom";
import * as yup from "yup";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { showToast } from "../../redux/Reducer/toastReducer";
import CircularProgress from "@mui/material/CircularProgress";
import { sendMail } from "../../services/transaction.service";

const AddProjectManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const selectedData = location?.state?.data;
  const formType = location?.state?.formType;
  const disabled = formType === "view" ? true : false;
  const initialValues = {
    projectName: selectedData?.projectName,
    clientId: selectedData?.clientId,
    projectManagerId: selectedData?.projectManagerId,
    projectStartDate: selectedData?.projectStartDate,
    projectEndDate: selectedData?.projectEndDate,
    formId: selectedData?.formId,
    upComingSurveyDate: selectedData?.upComingSurveyDate,
    surveyInterval: selectedData?.surveyInterval,
    primaryUser: selectedData?.primaryUser,
    comments: selectedData?.comments,
  };

  const [openLoader, setOpenLoader] = useState(false);
  // const [contactPersonData, setContactPersonData] = useState(
  //   formType === "add"
  //     ? [
  //         {
  //           name: "",
  //           position: "",
  //           email: "",
  //           mobileNumber: "",
  //           primary: true,
  //           isEdit: true,
  //         },
  //       ]
  //     : selectedData?.contact
  // );

  const [primaryUser2, setPrimaryUser2] = useState("");
  const setPrimary = (emailId, contact) => {
    return contact.map((cont) => ({
      ...cont,
      primary: cont.email === emailId,
    }));
  };
  const getPrimary = (contact) => {
    return contact.filter((cont) => cont.primary);
  };

  useEffect(() => {
    const primary = getPrimary(contactPersonData)[0];
    setPrimaryUser2(primary);
    initialValues.primaryUser = primary;
  }, []);

  const [contactPersonData, setContactPersonData] = useState(() => {
    if (formType === "add") {
      return [];
    } else {
      return (
        selectedData?.contact?.map((row) => ({
          ...row,
          isSave: true,
        })) || []
      );
    }
  });
  console.log(contactPersonData, "CPD");
  const [documentsData, setDocumentsData] = useState(
    formType === "add"
      ? [{ docName: "", file: null, fileName: "" }]
      : selectedData?.documents.map((el) => ({ ...el, file: el.location }))
  );

  const validationSchema = yup.object().shape({
    projectName: yup.string().required("Project Name Required *"),
    clientId: yup.string().required("Client Name Required *"),
    projectManagerId: yup.string().required("Project Manager Required *"),
    projectStartDate: yup.string().required("Project Start date Required *"),
    projectEndDate: yup.string().required("Project End date Required *"),
    formId: yup.string().required("Form Name Required *"),
    upComingSurveyDate: yup
      .string()
      .required("Upcoming Survey Date Required *"),
    surveyInterval: yup.string().required("Survey End date Required *"),
  });

  const sendMailFunction = async () => {
    try {
      console.log("selected data: ", selectedData)
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];

      const values = {
        surveyDate: formattedDate,
        userEmail: primaryUser2.email,
      };
      const res = await sendMail(selectedData._id, values);
      navigate(-1);
      dispatch(showToast({ message: res?.message, type: "success" }));
    } catch (error) {
      console.log(error);
    }
  };

  const [clientData, setClientData] = useState([]);
  const [formsData, setFormsData] = useState([]);
  const [projectManagerData, setProjectManagerData] = useState([]);

  const handleContactAdd = () => {
    setContactPersonData([
      ...contactPersonData,
      {
        name: "",
        position: "",
        email: "",
        mobileNumber: "",
        primary: false,
        isEdit: true,
        isCheck: false,
        isSave: false,
      },
    ]);
  };

  const handleContactDelete = (index) => {
    setContactPersonData(contactPersonData.filter((_, i) => i !== index));
  };

  const handleContactEdit = (index) => {
    setContactPersonData((prevData) =>
      prevData.map((el, ind) => ({
        ...el,
        isEdit: ind === index ? true : false,
      }))
    );
  };

  const handleContactSave = (index) => {
    const contact = contactPersonData[index];
    const emptyFields = [];
    if (!contact.name) emptyFields.push("Name");
    if (!contact.position) emptyFields.push("Position");
    if (!contact.email) emptyFields.push("Email");
    if (!contact.mobileNumber) emptyFields.push("Mobile Number");
    // if (!contact.primary) emptyFields.push("Primary");

    if (emptyFields.length > 0) {
      const errorMessage = `Please fill :${emptyFields.join(", ")}.`;

      dispatch(
        showToast({
          message: errorMessage,
          type: "error",
        })
      );
      return;
    }

    // setContactPersonData((prevData) =>
    //   prevData.map((el, ind) => (ind === index ? { ...el, isEdit: false } : el))
    // );
    setContactPersonData((prevData) =>
      prevData.map((el, ind) =>
        ind === index
          ? { ...el, isEdit: false, isSave: true } // Set isSave to true when saved
          : el
      )
    );
  };

  const handleContactChange = (e, field, index) => {
    if (e.target.type === "text") {
      setContactPersonData((prevData) =>
        prevData.map((el, ind) =>
          ind === index ? { ...el, [field]: e.target.value } : el
        )
      );
    } else {
      if (e.target.checked) {
        setContactPersonData((prevData) =>
          prevData.map((el, ind) =>
            ind === index
              ? { ...el, [field]: e.target.checked }
              : { ...el, [field]: false }
          )
        );
      }
    }
  };

  const handleDocumentsAdd = () => {
    setDocumentsData([
      ...documentsData,
      {
        docName: "",
        file: "",
      },
    ]);
  };

  const handleDocumentChange = (e, field, index) => {
    if (field === "file") {
      setDocumentsData((prevData) =>
        prevData.map((el, ind) =>
          ind === index
            ? { [field]: e, fileName: e.name, docName: el.docName }
            : el
        )
      );
    } else {
      setDocumentsData((prevData) =>
        prevData.map((el, ind) =>
          ind === index ? { ...el, [field]: e.target.value } : el
        )
      );
    }
  };

  const handleDocumentDelete = (index) => {
    setDocumentsData(documentsData.filter((_, i) => i !== index));
  };

  const handleSave = (values) => {
    const formattedDate = values?.upComingSurveyDate
      ? new Date(values.upComingSurveyDate).toLocaleDateString("en-GB", {
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "2-digit",
        })
      : null;
    setOpenLoader(true);
    const formData = new FormData();
    let contact = setPrimary(values.primaryUser, contactPersonData);
    formData.append(
      "values",
      JSON.stringify({ ...values, upComingSurveyDate: formattedDate, contact })
    );
    // setOpenLoader(true);
    // const formData = new FormData();
    // formData.append(
    //   "values",
    //   JSON.stringify({ ...values, contact: contactPersonData })
    // );
    documentsData.forEach((file) => {
      if (file.file) {
        formData.append(file.docName, file.file);
      }
    });

    if (formType === "edit") {
      formData.append("documentsData", JSON.stringify(documentsData));
    }

    const apiType =
      formType === "edit"
        ? updateProject(selectedData?._id, formData)
        : postProject(formData);
    apiType
      .then((res) => {
        dispatch(showToast({ message: res.message, type: "success" }));

        setOpenLoader(false);
        navigate(-1);
      })
      .catch((error) => {
        console.log(error);
        setOpenLoader(false);
      });
  };

  React.useEffect(() => {
    getClient().then((res) => {
      const modifiedData = res.data.map((el) => ({
        ...el,
        label: el?.name,
      }));
      setClientData(modifiedData);
    });
  }, []);

  React.useEffect(() => {
    getForm().then((res) => {
      const modifiedData = res.data.map((el) => ({
        ...el,
        label: el?.formName,
      }));
      setFormsData(modifiedData);
    });
  }, []);

  React.useEffect(() => {
    getUser().then((res) => {
      const modifiedData = res?.data?.data?.map((el) => ({
        ...el,
        label: el?.name,
      }));
      setProjectManagerData(modifiedData);
    });
  }, []);

  const primaryoptions = contactPersonData
    .filter((person) => person.isSave)
    .map((person) => ({
      label: person.name,
      value: person.email,
    }));

  return (
    <div className="mainContent">
      <div className="formContainer" style={{ border: "1px solid #D5D7E8" }}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSave(values);
          }}
        >
          {({ setFieldValue, values, errors, touched }) => (
            <Form>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px 14px",
                  alignItems: "center",
                }}
              >
                <Typography className="formHeader">
                  {formType === "view"
                    ? "View"
                    : formType === "edit"
                    ? "Edit"
                    : "Add New"}{" "}
                  Project
                </Typography>
                <Box sx={{ display: "flex", gap: "10px" }}>
                  <Button
                    className="cancelButton"
                    startIcon={<CloseIcon />}
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="addButton"
                    type="submit"
                    endIcon={
                      openLoader ? (
                        <CircularProgress size={20} color="#FFFFFF" />
                      ) : null
                    }
                    startIcon={<SaveIcon />}
                    sx={{ display: formType === "view" ? "none" : "flex" }}
                  >
                    {formType === "edit" ? "Update" : "Save"}
                  </Button>
                </Box>
              </Box>
              <Divider />
              <Box sx={{ padding: "10px 14px" }}>
                <Box mt={2} mb={3}>
                  <Typography
                    className="inputTitle"
                    sx={{ fontSize: "16px", paddingBottom: "10px" }}
                  >
                    Project Information :-
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid size={{ xs: 12, sm: 6, md: 4, xl: 4 }}>
                      <Typography
                        className="inputTitle"
                        sx={{ fontSize: "12px" }}
                      >
                        Project Name
                      </Typography>
                      <Field
                        disabled={disabled}
                        name="projectName"
                        className="InputField"
                        placeholder="Enter Project Name"
                      />
                      <div className="form-error">
                        {touched.projectName && errors.projectName
                          ? errors.projectName
                          : null}
                      </div>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4, xl: 4 }}>
                      <Typography
                        className="inputTitle"
                        sx={{ fontSize: "12px" }}
                      >
                        Client Name
                      </Typography>
                      <AutoComplete
                        disabled={disabled}
                        onChange={(e, v) => setFieldValue("clientId", v?._id)}
                        options={clientData}
                        placeholder="Select Project Name"
                        value={values?.clientId}
                      />
                      <div className="form-error">
                        {touched.clientId && errors.clientId
                          ? errors.clientId
                          : null}
                      </div>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4, xl: 4 }}>
                      <Typography
                        className="inputTitle"
                        sx={{ fontSize: "12px" }}
                      >
                        Project Manager
                      </Typography>
                      <AutoComplete
                        disabled={disabled}
                        onChange={(e, v) =>
                          setFieldValue("projectManagerId", v?._id)
                        }
                        options={projectManagerData}
                        placeholder="Select Project Manage"
                        value={values?.projectManagerId}
                      />
                      <div className="form-error">
                        {touched.projectManagerId && errors.projectManagerId
                          ? errors.projectManagerId
                          : null}
                      </div>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4, xl: 4 }}>
                      <Typography
                        className="inputTitle"
                        sx={{ fontSize: "12px" }}
                      >
                        Project Start Date
                      </Typography>
                      <DatePicker
                        disabled={disabled}
                        onChange={(e) =>
                          setFieldValue("projectStartDate", e?.$d)
                        }
                        value={values?.projectStartDate}
                      />
                      <div className="form-error">
                        {touched.projectStartDate && errors.projectStartDate
                          ? errors.projectStartDate
                          : null}
                      </div>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4, xl: 4 }}>
                      <Typography
                        className="inputTitle"
                        sx={{ fontSize: "12px" }}
                      >
                        Project End Date
                      </Typography>
                      <DatePicker
                        disabled={disabled}
                        onChange={(e) => setFieldValue("projectEndDate", e?.$d)}
                        value={values?.projectEndDate}
                        disableDate={
                          values?.projectStartDate
                            ? new Date(values.projectStartDate)
                            : new Date()
                        }
                      />
                      <div className="form-error">
                        {touched.projectEndDate && errors.projectEndDate
                          ? errors.projectEndDate
                          : null}
                      </div>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4, xl: 4 }}>
                      <Typography
                        className="inputTitle"
                        sx={{ fontSize: "12px" }}
                      >
                        Form
                      </Typography>
                      <AutoComplete
                        disabled={disabled}
                        onChange={(e, v) => setFieldValue("formId", v?._id)}
                        options={formsData}
                        placeholder="Select Form"
                        value={values?.formId}
                      />
                      <div className="form-error">
                        {touched.formId && errors.formId ? errors.formId : null}
                      </div>
                    </Grid>
                  </Grid>
                </Box>
                <Divider />
                <Box mt={2} mb={3}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      className="inputTitle"
                      sx={{ fontSize: "16px" }}
                    >
                      Contact Person :-
                    </Typography>
                    <Button
                      sx={Styles[0].buttonStyle}
                      startIcon={<AddIcon />}
                      onClick={handleContactAdd}
                      disabled={disabled}
                    >
                      Add
                    </Button>
                  </Box>
                  <Box>
                    <TableContainer
                      sx={{
                        border: "1px solid #D5D7E8",
                        borderRadius: "10px",
                      }}
                    >
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell sx={Styles[0].tableHeader}>
                              Name
                            </TableCell>
                            <TableCell sx={Styles[0].tableHeader}>
                              Position
                            </TableCell>
                            <TableCell sx={Styles[0].tableHeader}>
                              Email ID
                            </TableCell>
                            <TableCell sx={Styles[0].tableHeader}>
                              Mobile Number
                            </TableCell>
                            {/* <TableCell sx={Styles[0].tableHeader}>
                              Primary
                            </TableCell> */}
                            <TableCell
                              align="center"
                              sx={Styles[0].tableHeader}
                            >
                              Actions
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {contactPersonData.length > 0 ? (
                            contactPersonData.map((row, index) => (
                              <TableRow key={index}>
                                <TableCell sx={Styles[0].tableBody}>
                                  {row.isEdit ? (
                                    <input
                                      style={Styles[0].inputStyle}
                                      value={row.name}
                                      onChange={(e) =>
                                        handleContactChange(e, "name", index)
                                      }
                                      placeholder="Enter Name"
                                    />
                                  ) : (
                                    row?.name
                                  )}
                                </TableCell>
                                <TableCell sx={Styles[0].tableBody}>
                                  {row.isEdit ? (
                                    <input
                                      style={Styles[0].inputStyle}
                                      value={row.position}
                                      onChange={(e) =>
                                        handleContactChange(
                                          e,
                                          "position",
                                          index
                                        )
                                      }
                                      placeholder="Enter Position"
                                    />
                                  ) : (
                                    row.position
                                  )}
                                </TableCell>
                                <TableCell sx={Styles[0].tableBody}>
                                  {row.isEdit ? (
                                    <input
                                      style={Styles[0].inputStyle}
                                      value={row.email}
                                      onChange={(e) =>
                                        handleContactChange(e, "email", index)
                                      }
                                      placeholder="Enter Email"
                                    />
                                  ) : (
                                    row.email
                                  )}
                                </TableCell>
                                <TableCell sx={Styles[0].tableBody}>
                                  {row.isEdit ? (
                                    <input
                                      style={Styles[0].inputStyle}
                                      value={row.mobileNumber}
                                      onChange={(e) =>
                                        handleContactChange(
                                          e,
                                          "mobileNumber",
                                          index
                                        )
                                      }
                                      placeholder="Enter Mobile Number"
                                      maxlength="10"
                                      type="text"
                                      onInput={(e) => {
                                        e.target.value = e.target.value.replace(
                                          /\D/g,
                                          ""
                                        );
                                      }}
                                    />
                                  ) : (
                                    row.mobileNumber
                                  )}
                                </TableCell>
                                {/* <TableCell sx={Styles[0].tableBody}>
                                  {row.isEdit ? (
                                    <input
                                      style={Styles[0].inputStyle}
                                      type="checkbox"
                                      checked={row.primary}
                                      onChange={(e) =>
                                        handleContactChange(e, "primary", index)
                                      }
                                    />
                                  ) : row.isCheck ? (
                                    ""
                                  ) : (
                                    <input
                                      type="checkbox"
                                      checked={row.primary}
                                    />
                                  )}
                                </TableCell> */}
                                <TableCell align="center">
                                  {row.isEdit ? (
                                    <Button
                                      onClick={() => handleContactSave(index)}
                                      startIcon={<SaveIcon />}
                                    />
                                  ) : row.isSave ? (
                                    <>
                                      <Button
                                        onClick={() => handleContactEdit(index)}
                                        startIcon={<EditIcon />}
                                        disabled={disabled}
                                      />
                                      <Button
                                        onClick={() =>
                                          handleContactDelete(index)
                                        }
                                        startIcon={<DeleteIcon />}
                                        disabled={disabled}
                                      />
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={6} align="center">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                  }}
                                >
                                  <Typography sx={{ m: 2, fontWeight: 700 }}>
                                    It's Empty Here!
                                  </Typography>
                                </div>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box>
                <Divider />

                <Box mt={2} mb={3}>
                  <Typography
                    className="inputTitle"
                    sx={{ fontSize: "16px", paddingBottom: "10px" }}
                  >
                    Survey Information :-
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid
                      size={{
                        xs: 12,
                        sm: 6,
                        md: formType === "view" ? 3.5 : 4,
                      }}
                    >
                      <Typography
                        className="inputTitle"
                        sx={{ fontSize: "12px" }}
                      >
                        Upcoming Survey Date
                      </Typography>
                      <DatePicker
                        disabled={disabled}
                        onChange={(e) =>
                          setFieldValue("upComingSurveyDate", e?.$d)
                        }
                        value={values?.upComingSurveyDate}
                        disableDate={true}
                      />
                      <div className="form-error">
                        {touched.upComingSurveyDate && errors.upComingSurveyDate
                          ? errors.upComingSurveyDate
                          : null}
                      </div>
                    </Grid>
                    <Grid
                      size={{
                        xs: 12,
                        sm: 6,
                        md: formType === "view" ? 3.5 : 4,
                      }}
                    >
                      <Typography
                        className="inputTitle"
                        sx={{ fontSize: "12px" }}
                      >
                        Survey Interval
                      </Typography>
                      <AutoComplete
                        disabled={disabled}
                        onChange={(e, v) =>
                          setFieldValue("surveyInterval", v?._id)
                        }
                        options={surveyIntervalOptions}
                        placeholder="Select Form"
                        value={values?.surveyInterval}
                      />
                      <div className="form-error">
                        {touched.surveyInterval && errors.surveyInterval
                          ? errors.surveyInterval
                          : null}
                      </div>
                    </Grid>
                    <Grid
                      size={{
                        xs: 12,
                        sm: 6,
                        md: formType === "view" ? 3.5 : 4,
                      }}
                    >
                      <Typography
                        className="inputTitle"
                        sx={{ fontSize: "12px" }}
                      >
                        Survey Send To
                      </Typography>
                      <Autocomplete
                        disabled={disabled}
                        options={primaryoptions}
                        onChange={(e, v) => {
                          console.log(v, "SSS");
                          return setFieldValue("primaryUser", v?.value);
                        }}
                        placeholder="Select Form"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Add Contact Person"
                            InputProps={{
                              ...params.InputProps,
                              style: {
                                fontSize: "12px",
                                height: "38px",
                                paddingLeft: "10px",
                              },
                            }}
                            InputLabelProps={{
                              style: { fontSize: "14px" },
                            }}
                          />
                        )}
                        // value={values?.primaryUser || null}
                        // value={
                        //   primaryoptions.find(
                        //     (option) => option.value === values?.primaryUser
                        //   ) || null
                        // }
                        // value={
                        //   values?.primaryUser
                        //     ? values?.primaryUser
                        //     : primaryUser2?.name ||
                        //       primaryoptions.find((option) => option?.primary)
                        //         ?.name ||
                        //       ""
                        // }
                        value={
                          values?.primaryUser
                            ? primaryoptions.find(
                                (option) => option.value === values?.primaryUser
                              ) || null
                            : primaryUser2?.name ||
                              primaryoptions.find((option) => option?.primary)
                                ?.name ||
                              ""
                        }
                      />
                      {/* <div className="form-error">
                        {touched.surveyInterval && errors.surveyInterval
                          ? errors.surveyInterval
                          : null}
                      </div> */}
                    </Grid>
                    {formType === "view" && (
                      <Grid size={{ xs: 12, sm: 6, md: 1.5 }}>
                        <Typography
                          className="inputTitle"
                          sx={{ fontSize: "12px" }}
                        >
                          Send Feedback
                        </Typography>
                        <Button
                          className="addButton"
                          sx={{ width: "100%" }}
                          onClick={sendMailFunction}
                        >
                          Send
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                </Box>
                <Divider />
                <Box mt={2} mb={2}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      className="inputTitle"
                      sx={{ fontSize: "16px" }}
                    >
                      Documents :-
                    </Typography>
                    <Button
                      sx={Styles[0].buttonStyle}
                      startIcon={<AddIcon />}
                      onClick={handleDocumentsAdd}
                      disabled={disabled}
                    >
                      Add
                    </Button>
                  </Box>
                  <Box>
                    <Grid container spacing={3}>
                      {documentsData?.map((doc, ind) => (
                        <React.Fragment key={ind}>
                          <Grid size={{ xs: 12, sm: 5, md: 5, xl: 5 }}>
                            <Typography
                              className="inputTitle"
                              sx={{ fontSize: "12px" }}
                            >
                              Documents - {ind + 1}
                            </Typography>
                            <input
                              placeholder="Enter File Name"
                              className="InputField"
                              onChange={(e) =>
                                handleDocumentChange(e, "docName", ind)
                              }
                              disabled={disabled}
                              value={doc?.docName}
                            />
                          </Grid>
                          <Grid
                            size={{ xs: 12, sm: 5, md: 5, xl: 5 }}
                            className="File-Upload"
                          >
                            <Typography
                              className="inputTitle"
                              sx={{ fontSize: "12px" }}
                            >
                              File
                            </Typography>
                            <FileUploader
                              disabled={disabled}
                              name="file"
                              handleChange={(e) =>
                                handleDocumentChange(e, "file", ind)
                              }
                              multiple={false}
                              dropMessageStyle={{
                                color: "green",
                                border: "none",
                                borderRadius: "0px",
                              }}
                            />
                            <Box className="uploadIcon">
                              {doc?.fileName ? (
                                <h6
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    fontFamily: "Open Sans, sans-serif",
                                  }}
                                >
                                  {/* {doc.fileName?.length>15} */}
                                  {doc?.fileName?.length > 20
                                    ? `${doc.fileName.substring(0, 20)}...`
                                    : doc?.fileName}
                                </h6>
                              ) : (
                                <React.Fragment>
                                  <CloudUploadOutlinedIcon className="cloud-icon" />
                                  Drag & Drop or click to upload files
                                </React.Fragment>
                              )}
                            </Box>
                          </Grid>
                          <Grid size={{ xs: 12, sm: 2, md: 2, xl: 2 }}>
                            <Typography
                              className="InputTitle"
                              sx={{ marginBottom: "-2px" }}
                            >
                              &nbsp;
                            </Typography>
                            <RemoveRedEyeIcon
                              sx={{
                                ...Styles[0].editIconStyle,
                                display:
                                  formType === "view" ? "inline" : "none",
                              }}
                              onClick={() => window.open(doc.file)}
                            />
                            <DeleteOutlineOutlinedIcon
                              disabled={disabled}
                              onClick={() => handleDocumentDelete(ind)}
                              sx={{
                                ...Styles[0].deleteIconStyle,
                                display: disabled ? "none" : "inline",
                              }}
                            />
                          </Grid>
                        </React.Fragment>
                      ))}
                    </Grid>
                  </Box>
                </Box>
                <Divider />
                <Box mt={2} mb={2}>
                  <Grid container spacing={3}>
                    <Grid size={{ xs: 12, sm: 12 }}>
                      <Typography
                        className="inputTitle"
                        sx={{ paddingBottom: "10px", fontSize: "16px" }}
                      >
                        Comments :-
                      </Typography>
                      <Field
                        disabled={disabled}
                        name="comments"
                        as="textarea"
                        className="InputField"
                        style={{
                          height: "100px",
                          width: "100%",
                          resize: formType === "view" ? "none" : "both",
                        }}
                        placeholder="Write your comments here"
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddProjectManagement;

const surveyIntervalOptions = [
  { label: "1 Month", _id: 1 },
  { label: "2 Months", _id: 2 },
  { label: "3 Months", _id: 3 },
  { label: "4 Months", _id: 4 },
  { label: "5 Months", _id: 5 },
  { label: "6 Months", _id: 6 },
  { label: "7 Months", _id: 7 },
  { label: "8 Months", _id: 8 },
  { label: "9 Months", _id: 9 },
  { label: "10 Months", _id: 10 },
  { label: "11 Months", _id: 11 },
  { label: "12 Months", _id: 12 },
];

const Styles = [
  {
    buttonStyle: {
      backgroundColor: "white",
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 600,
      color: "#00675D",
    },
    inputStyle: {
      border: "1px solid #ccc",
      padding: "10px 0 6px 8px",
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 600,
      outline: "none",
      backgroundColor: "transparent",
      fontSize: "12px",
      borderRadius: "2px",
    },
    editIconStyle: {
      padding: "6px",
      border: "1px solid #D5D7E8",
      borderRadius: "5px",
      color: "#00675D",
      cursor: "pointer",
      height: "38px",
      width: "35px",
    },
    deleteIconStyle: {
      backgroundColor: "#FFE7E7",
      padding: "6px",
      marginLeft: "12px",
      borderRadius: "5px",
      color: "#DB3A3A",
      cursor: "pointer",
      border: "1px solid #D5D7E8",
      height: "38px",
      width: "35px",
    },
    tableHeader: {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 400,
      fontSize: "14px",
    },
    tableBody: {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 400,
      fontSize: "12px",
    },
  },
];
